import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { deleteRequest } from 'src/utils/request';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import messages from '../../messages';

const createCandidateCertificate = async (params: {
  uuid: string;
  certificateCode: string;
}) => {
  const { uuid, certificateCode } = params;

  return await deleteRequest(
    API.DELETE.deleteCandidateCertificate(uuid, certificateCode),
  );
};

export const useDeleteCandidateCertificate = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: createCandidateCertificate,
    onSuccess: (_, { uuid }) => {
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.CANDIDATE_DETAILS, uuid],
      });
      handleSuccess(formatMessage(messages.certificateDeleted));
    },
    onError: handleError,
  });
};
